import {useIsElementDark} from '~/utils/useIsElementDark'

export const EnterprisePlanIcon = () => {
  const {ref, isDarkMode} = useIsElementDark()

  if (isDarkMode) {
    return (
      <svg
        ref={ref}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="icons8-building 2" clipPath="url(#clip0_2574_15554)">
          <g id="Group">
            <g id="Group_2">
              <path
                id="Vector"
                d="M21.75 4.875C21.1125 4.875 20.625 5.3625 20.625 6V42.75C20.625 43.3875 21.1125 43.875 21.75 43.875C22.3875 43.875 22.875 43.3875 22.875 42.75V6C22.875 5.3625 22.3875 4.875 21.75 4.875Z"
                fill="#6610F2"
              />
              <path
                id="Vector_2"
                d="M11.7008 43.1623C11.7383 43.2373 11.7758 43.3123 11.8133 43.3498C11.8508 43.4248 11.8883 43.4623 11.9633 43.5373C12.1883 43.7623 12.4508 43.8748 12.7508 43.8748C13.0508 43.8748 13.3508 43.7623 13.5383 43.5373C13.7633 43.3123 13.8758 43.0498 13.8758 42.7498C13.8758 42.6748 13.8758 42.5998 13.8383 42.5248C13.8383 42.4498 13.8008 42.3748 13.7633 42.2998C13.7258 42.2248 13.6883 42.1873 13.6508 42.1123C13.6133 42.0373 13.5758 41.9998 13.5008 41.9248C13.4633 41.8873 13.3883 41.8123 13.3508 41.7748C13.2758 41.7373 13.2383 41.6998 13.1633 41.6623C13.0883 41.6248 13.0133 41.6248 12.9383 41.5873C12.5633 41.5123 12.1883 41.6248 11.9258 41.8873C11.8883 41.9248 11.8133 41.9998 11.7758 42.0748C11.7383 42.1498 11.7008 42.1873 11.6633 42.2623C11.6258 42.3373 11.6258 42.4123 11.5883 42.4873C11.5883 42.5623 11.5508 42.6373 11.5508 42.7123C11.5508 42.7873 11.5508 42.8623 11.5883 42.9373C11.6633 43.0498 11.6633 43.1248 11.7008 43.1623Z"
                fill="#6610F2"
              />
              <path
                id="Vector_3"
                d="M12.75 26.625C13.3713 26.625 13.875 26.1213 13.875 25.5C13.875 24.8787 13.3713 24.375 12.75 24.375C12.1287 24.375 11.625 24.8787 11.625 25.5C11.625 26.1213 12.1287 26.625 12.75 26.625Z"
                fill="#6610F2"
              />
              <path
                id="Vector_4"
                d="M12.75 22.3125C13.3713 22.3125 13.875 21.8088 13.875 21.1875C13.875 20.5662 13.3713 20.0625 12.75 20.0625C12.1287 20.0625 11.625 20.5662 11.625 21.1875C11.625 21.8088 12.1287 22.3125 12.75 22.3125Z"
                fill="#6610F2"
              />
              <path
                id="Vector_5"
                d="M12.75 39.5625C13.3713 39.5625 13.875 39.0588 13.875 38.4375C13.875 37.8162 13.3713 37.3125 12.75 37.3125C12.1287 37.3125 11.625 37.8162 11.625 38.4375C11.625 39.0588 12.1287 39.5625 12.75 39.5625Z"
                fill="#6610F2"
              />
              <path
                id="Vector_6"
                d="M12.75 35.25C13.3713 35.25 13.875 34.7463 13.875 34.125C13.875 33.5037 13.3713 33 12.75 33C12.1287 33 11.625 33.5037 11.625 34.125C11.625 34.7463 12.1287 35.25 12.75 35.25Z"
                fill="#6610F2"
              />
              <path
                id="Vector_7"
                d="M12.75 30.9375C13.3713 30.9375 13.875 30.4338 13.875 29.8125C13.875 29.1912 13.3713 28.6875 12.75 28.6875C12.1287 28.6875 11.625 29.1912 11.625 29.8125C11.625 30.4338 12.1287 30.9375 12.75 30.9375Z"
                fill="#6610F2"
              />
              <path
                id="Vector_8"
                d="M12.7504 18.0008C13.0504 18.0008 13.3504 17.8883 13.5379 17.6633C13.7629 17.4383 13.8754 17.1758 13.8754 16.8758C13.8754 16.5758 13.7629 16.2758 13.5379 16.0883C13.5004 16.0508 13.4254 15.9758 13.3879 15.9383C13.3129 15.9008 13.2754 15.8633 13.2004 15.8258C13.1254 15.7883 13.0504 15.7883 12.9754 15.7508C12.8254 15.7133 12.6754 15.7133 12.5254 15.7508C12.4504 15.7508 12.3754 15.7883 12.3004 15.8258C12.2254 15.8633 12.1879 15.9008 12.1129 15.9383C12.0379 15.9758 12.0004 16.0133 11.9629 16.0883C11.9254 16.1633 11.8504 16.2008 11.8129 16.2758C11.7754 16.3508 11.7379 16.3883 11.7004 16.4633C11.6629 16.5383 11.6629 16.6133 11.6254 16.6883C11.6254 16.7633 11.5879 16.8383 11.5879 16.9133C11.5879 17.2133 11.7004 17.5133 11.9254 17.7008C12.1504 17.8883 12.4504 18.0008 12.7504 18.0008Z"
                fill="#6610F2"
              />
              <path
                id="Vector_9"
                d="M26.25 4.875C25.6125 4.875 25.125 5.3625 25.125 6V42.75C25.125 43.3875 25.6125 43.875 26.25 43.875C26.8875 43.875 27.375 43.3875 27.375 42.75V6C27.375 5.3625 26.8875 4.875 26.25 4.875Z"
                fill="#6610F2"
              />
              <path
                id="Vector_10"
                d="M34.875 39.375C35.4963 39.375 36 38.8713 36 38.25C36 37.6287 35.4963 37.125 34.875 37.125C34.2537 37.125 33.75 37.6287 33.75 38.25C33.75 38.8713 34.2537 39.375 34.875 39.375Z"
                fill="#6610F2"
              />
              <path
                id="Vector_11"
                d="M34.875 41.625C34.2375 41.625 33.75 42.1125 33.75 42.75C33.75 43.35 34.2375 43.875 34.875 43.875C35.5125 43.875 36 43.35 36 42.75C36 42.1125 35.5125 41.625 34.875 41.625Z"
                fill="#6610F2"
              />
              <path
                id="Vector_12"
                d="M34.875 34.875C35.4963 34.875 36 34.3713 36 33.75C36 33.1287 35.4963 32.625 34.875 32.625C34.2537 32.625 33.75 33.1287 33.75 33.75C33.75 34.3713 34.2537 34.875 34.875 34.875Z"
                fill="#6610F2"
              />
              <path
                id="Vector_13"
                d="M34.875 25.875C35.4963 25.875 36 25.3713 36 24.75C36 24.1287 35.4963 23.625 34.875 23.625C34.2537 23.625 33.75 24.1287 33.75 24.75C33.75 25.3713 34.2537 25.875 34.875 25.875Z"
                fill="#6610F2"
              />
              <path
                id="Vector_14"
                d="M34.875 21.375C35.4963 21.375 36 20.8713 36 20.25C36 19.6287 35.4963 19.125 34.875 19.125C34.2537 19.125 33.75 19.6287 33.75 20.25C33.75 20.8713 34.2537 21.375 34.875 21.375Z"
                fill="#6610F2"
              />
              <path
                id="Vector_15"
                d="M34.875 30.375C35.4963 30.375 36 29.8713 36 29.25C36 28.6287 35.4963 28.125 34.875 28.125C34.2537 28.125 33.75 28.6287 33.75 29.25C33.75 29.8713 34.2537 30.375 34.875 30.375Z"
                fill="#6610F2"
              />
              <path
                id="Vector_16"
                d="M46.5 45.375H45V20.25C45 19.6125 44.5125 19.125 43.875 19.125H40.5V12.75C40.5 12.1125 40.0125 11.625 39.375 11.625H36V8.25C36 7.6125 35.5125 7.125 34.875 7.125H31.5V1.5C31.5 0.8625 31.0125 0.375 30.375 0.375H17.25C16.6125 0.375 16.125 0.8625 16.125 1.5V7.125H12.75C12.1125 7.125 11.625 7.6125 11.625 8.25V11.625H8.25C7.6125 11.625 7.125 12.1125 7.125 12.75V19.125H3.75C3.1125 19.125 2.625 19.6125 2.625 20.25V45.375H1.5C0.8625 45.375 0.375 45.8625 0.375 46.5C0.375 47.1375 0.8625 47.625 1.5 47.625H17.25H30.375H46.5C47.1375 47.625 47.625 47.1375 47.625 46.5C47.625 45.8625 47.1375 45.375 46.5 45.375ZM42.75 21.375V45.375H40.5V21.375H42.75ZM38.25 45.375H31.5V13.875H38.25V45.375ZM33.75 9.375V11.625H31.5V9.375H33.75ZM13.875 9.375H16.125V11.625H13.875V9.375ZM9.375 13.875H16.125V45.375H9.375V13.875ZM4.875 21.375H7.125V45.375H4.875V21.375ZM18.375 45.375V2.625H29.25V45.375H18.375Z"
                fill="white"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_2574_15554">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg
      ref={ref}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icons8-building 2" clipPath="url(#clip0_2574_15510)">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M3.75 46.5V20.25H8.25V12.75H12.75V8.25H17.25V1.5H30.375V8.25H34.875V12.75H39.375V20.25H43.875V46.5H3.75Z"
              fill="white"
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_2"
              d="M21.75 4.875C21.1125 4.875 20.625 5.3625 20.625 6V42.75C20.625 43.3875 21.1125 43.875 21.75 43.875C22.3875 43.875 22.875 43.3875 22.875 42.75V6C22.875 5.3625 22.3875 4.875 21.75 4.875Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_3"
              d="M11.7008 43.1623C11.7383 43.2373 11.7758 43.3123 11.8133 43.3498C11.8508 43.4248 11.8883 43.4623 11.9633 43.5373C12.1883 43.7623 12.4508 43.8748 12.7508 43.8748C13.0508 43.8748 13.3508 43.7623 13.5383 43.5373C13.7633 43.3123 13.8758 43.0498 13.8758 42.7498C13.8758 42.6748 13.8758 42.5998 13.8383 42.5248C13.8383 42.4498 13.8008 42.3748 13.7633 42.2998C13.7258 42.2248 13.6883 42.1873 13.6508 42.1123C13.6133 42.0373 13.5758 41.9998 13.5008 41.9248C13.4633 41.8873 13.3883 41.8123 13.3508 41.7748C13.2758 41.7373 13.2383 41.6998 13.1633 41.6623C13.0883 41.6248 13.0133 41.6248 12.9383 41.5873C12.5633 41.5123 12.1883 41.6248 11.9258 41.8873C11.8883 41.9248 11.8133 41.9998 11.7758 42.0748C11.7383 42.1498 11.7008 42.1873 11.6633 42.2623C11.6258 42.3373 11.6258 42.4123 11.5883 42.4873C11.5883 42.5623 11.5508 42.6373 11.5508 42.7123C11.5508 42.7873 11.5508 42.8623 11.5883 42.9373C11.6633 43.0498 11.6633 43.1248 11.7008 43.1623Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_4"
              d="M12.75 26.625C13.3713 26.625 13.875 26.1213 13.875 25.5C13.875 24.8787 13.3713 24.375 12.75 24.375C12.1287 24.375 11.625 24.8787 11.625 25.5C11.625 26.1213 12.1287 26.625 12.75 26.625Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_5"
              d="M12.75 22.3125C13.3713 22.3125 13.875 21.8088 13.875 21.1875C13.875 20.5662 13.3713 20.0625 12.75 20.0625C12.1287 20.0625 11.625 20.5662 11.625 21.1875C11.625 21.8088 12.1287 22.3125 12.75 22.3125Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_6"
              d="M12.75 39.5625C13.3713 39.5625 13.875 39.0588 13.875 38.4375C13.875 37.8162 13.3713 37.3125 12.75 37.3125C12.1287 37.3125 11.625 37.8162 11.625 38.4375C11.625 39.0588 12.1287 39.5625 12.75 39.5625Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_7"
              d="M12.75 35.25C13.3713 35.25 13.875 34.7463 13.875 34.125C13.875 33.5037 13.3713 33 12.75 33C12.1287 33 11.625 33.5037 11.625 34.125C11.625 34.7463 12.1287 35.25 12.75 35.25Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_8"
              d="M12.75 30.9375C13.3713 30.9375 13.875 30.4338 13.875 29.8125C13.875 29.1912 13.3713 28.6875 12.75 28.6875C12.1287 28.6875 11.625 29.1912 11.625 29.8125C11.625 30.4338 12.1287 30.9375 12.75 30.9375Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_9"
              d="M12.7504 18.0008C13.0504 18.0008 13.3504 17.8883 13.5379 17.6633C13.7629 17.4383 13.8754 17.1758 13.8754 16.8758C13.8754 16.5758 13.7629 16.2758 13.5379 16.0883C13.5004 16.0508 13.4254 15.9758 13.3879 15.9383C13.3129 15.9008 13.2754 15.8633 13.2004 15.8258C13.1254 15.7883 13.0504 15.7883 12.9754 15.7508C12.8254 15.7133 12.6754 15.7133 12.5254 15.7508C12.4504 15.7508 12.3754 15.7883 12.3004 15.8258C12.2254 15.8633 12.1879 15.9008 12.1129 15.9383C12.0379 15.9758 12.0004 16.0133 11.9629 16.0883C11.9254 16.1633 11.8504 16.2008 11.8129 16.2758C11.7754 16.3508 11.7379 16.3883 11.7004 16.4633C11.6629 16.5383 11.6629 16.6133 11.6254 16.6883C11.6254 16.7633 11.5879 16.8383 11.5879 16.9133C11.5879 17.2133 11.7004 17.5133 11.9254 17.7008C12.1504 17.8883 12.4504 18.0008 12.7504 18.0008Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_10"
              d="M26.25 4.875C25.6125 4.875 25.125 5.3625 25.125 6V42.75C25.125 43.3875 25.6125 43.875 26.25 43.875C26.8875 43.875 27.375 43.3875 27.375 42.75V6C27.375 5.3625 26.8875 4.875 26.25 4.875Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_11"
              d="M34.875 39.375C35.4963 39.375 36 38.8713 36 38.25C36 37.6287 35.4963 37.125 34.875 37.125C34.2537 37.125 33.75 37.6287 33.75 38.25C33.75 38.8713 34.2537 39.375 34.875 39.375Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_12"
              d="M34.875 41.625C34.2375 41.625 33.75 42.1125 33.75 42.75C33.75 43.35 34.2375 43.875 34.875 43.875C35.5125 43.875 36 43.35 36 42.75C36 42.1125 35.5125 41.625 34.875 41.625Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_13"
              d="M34.875 34.875C35.4963 34.875 36 34.3713 36 33.75C36 33.1287 35.4963 32.625 34.875 32.625C34.2537 32.625 33.75 33.1287 33.75 33.75C33.75 34.3713 34.2537 34.875 34.875 34.875Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_14"
              d="M34.875 25.875C35.4963 25.875 36 25.3713 36 24.75C36 24.1287 35.4963 23.625 34.875 23.625C34.2537 23.625 33.75 24.1287 33.75 24.75C33.75 25.3713 34.2537 25.875 34.875 25.875Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_15"
              d="M34.875 21.375C35.4963 21.375 36 20.8713 36 20.25C36 19.6287 35.4963 19.125 34.875 19.125C34.2537 19.125 33.75 19.6287 33.75 20.25C33.75 20.8713 34.2537 21.375 34.875 21.375Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_16"
              d="M34.875 30.375C35.4963 30.375 36 29.8713 36 29.25C36 28.6287 35.4963 28.125 34.875 28.125C34.2537 28.125 33.75 28.6287 33.75 29.25C33.75 29.8713 34.2537 30.375 34.875 30.375Z"
              fill="#BDB2FF"
            />
            <path
              id="Vector_17"
              d="M46.5 45.375H45V20.25C45 19.6125 44.5125 19.125 43.875 19.125H40.5V12.75C40.5 12.1125 40.0125 11.625 39.375 11.625H36V8.25C36 7.6125 35.5125 7.125 34.875 7.125H31.5V1.5C31.5 0.8625 31.0125 0.375 30.375 0.375H17.25C16.6125 0.375 16.125 0.8625 16.125 1.5V7.125H12.75C12.1125 7.125 11.625 7.6125 11.625 8.25V11.625H8.25C7.6125 11.625 7.125 12.1125 7.125 12.75V19.125H3.75C3.1125 19.125 2.625 19.6125 2.625 20.25V45.375H1.5C0.8625 45.375 0.375 45.8625 0.375 46.5C0.375 47.1375 0.8625 47.625 1.5 47.625H17.25H30.375H46.5C47.1375 47.625 47.625 47.1375 47.625 46.5C47.625 45.8625 47.1375 45.375 46.5 45.375ZM42.75 21.375V45.375H40.5V21.375H42.75ZM38.25 45.375H31.5V13.875H38.25V45.375ZM33.75 9.375V11.625H31.5V9.375H33.75ZM13.875 9.375H16.125V11.625H13.875V9.375ZM9.375 13.875H16.125V45.375H9.375V13.875ZM4.875 21.375H7.125V45.375H4.875V21.375ZM18.375 45.375V2.625H29.25V45.375H18.375Z"
              fill="#2B2D2E"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2574_15510">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
